import { ChannelChatManagementScreenNavigationProps } from "./types"
import React from "react"
import ChannelChatManagement from "./channel-chat-management-screen"
import { PageRoot } from "~screens/page-root"
import { useRouteChatId } from "~hooks/useActiveChat"

const ChannelChatManagementScreen: React.FC<ChannelChatManagementScreenNavigationProps> = (props) => {
  const chatKey = useRouteChatId() ?? "default"
  return (
    <PageRoot>
      <ChannelChatManagement key={chatKey} {...props}/>
    </PageRoot>
  )
}

export default ChannelChatManagementScreen
